import { Component } from '@angular/core';

@Component({
  selector: 'app-form-provider',
  template: ``,
  styleUrls: []
})
export class FormProviderComponent {

}
